import { PriorityHigh } from "@mui/icons-material";
import { Chip } from "@mui/material";
import React from "react";

interface Props {
  title: string;
  highPriority?: boolean;
}

const Pill: React.FC<Props> = (props) => {
  const { title, highPriority } = props;
  return (
    <Chip
      label={title}
      icon={highPriority ? <PriorityHigh fontSize="small" /> : undefined}
      variant="filled"
      color={highPriority ? "error" : "warning"}
    />
  );
};

export default Pill;
